<template>
  <div id="app" class="module" :class="`module--${chapter.config.id}`">
    <RotateScreen v-if="$vssWidth < 620 && $vssWidth < $vssHeight" />
    <div class="module__main">
      <Preloader />
      <Transition name="fade">
        <Screen
          v-if="currentScreen.type === 'screen'"
          ref="screen"
          class="module__screen"
          :class="`module__screen--${currentScreen.id}`"
          :key="currentScreen.id"
          :screen="currentScreen"
          :config="chapter.config"
          @video="openVideo"
          @prev="prevScreen"
          @next="nextScreen"
          @home="goHome"
        />
        <Quiz
          v-if="currentScreen.type === 'quiz'"
          ref="quiz"
          class="module__screen"
          :class="`module__screen--${currentScreen.id}`"
          :key="currentScreen.id"
          :quiz="currentScreen"
          :config="chapter.config"
          @video="openVideo"
          @prev="prevScreen"
          @next="nextScreen"
          @home="goHome"
        />
      </Transition>
    </div>
    <Toolbar
      class="module__toolbar"
      :video="typeof chapter.config.video !== 'undefined'"
      :prev="screen > 0"
      :next="nextActive"
      @video="openVideo"
      @prev="prevScreen"
      @next="nextScreen"
      @home="goHome"
    />
    <ul v-if="currentScreen && currentScreen.notes" class="module__notes">
      <li
        v-for="(note, i) in currentScreen.notes"
        :key="`note_${currentScreen.id}_${i}`"
      >
        {{ note }}
      </li>
    </ul>
    <ol v-if="currentScreen && currentScreen.refs" class="module__refs">
      <li
        v-for="(ref, i) in currentScreen.refs"
        :key="`ref_${currentScreen.id}_${i}`"
      >
        {{ ref }}
      </li>
    </ol>
    <div
      class="module__video"
      v-if="chapterVideo && videoVisible"
      @click="videoVisible = false"
    >
      <div
        class="module__video-holder"
        @click="
          (e) => {
            e.stopPropagation();
          }
        "
      >
        <div class="btn btn--round" @click="videoVisible = false">
          <svg
            viewBox="0 0 32 32"
            fill="none"
            stroke="currentcolor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
          >
            <path d="M2 30 L30 2 M30 30 L2 2" />
          </svg>
        </div>
        <vue-plyr>
          <video controls crossorigin playsinline autoplay>
            <source :src="chapterVideo" type="video/mp4" />
          </video>
        </vue-plyr>
      </div>
    </div>
  </div>
</template>

<script>
const chapter = window.chapter;

import RotateScreen from "@/components/rotate-screen";
import Screen from "@/components/screen";
import Quiz from "@/components/quiz";
import Toolbar from "@/components/toolbar";
import VuePlyr from "vue-plyr";
import Preloader from "@/components/preloader";
import "vue-plyr/dist/vue-plyr.css";

export default {
  components: {
    Screen,
    Quiz,
    Toolbar,
    VuePlyr,
    RotateScreen,
    Preloader,
  },
  data() {
    Preloader;
    return {
      screen: 0,
      videoVisible: false,
      chapter,
    };
  },
  computed: {
    chapterVideo() {
      return this.chapter.config.video
        ? this.chapter.config.base + "/" + this.chapter.config.video
        : false;
    },
    currentScreen() {
      return this.chapter.screens[this.screen];
    },
    nextActive() {
      if (
        this.currentScreen.type === "quiz" &&
        this.$refs.quiz &&
        !this.$refs.quiz.nextAllowed
      ) {
        return true;
      }
      return (
        this.screen < this.chapter.screens.length - 1 ||
        typeof this.chapter.config.next !== "undefined"
      );
    },
  },
  watch: {
    screen() {
      const e = new window.jQuery.Event("module-navigation", {
        detail: {
          chapter: this.chapter.config.id,
          screen: this.currentScreen.id,
        },
      });
      window.jQuery(document).trigger(e);
    },
  },
  methods: {
    openVideo() {
      this.videoVisible = !this.videoVisible;
    },
    prevScreen() {
      if (this.currentScreen.type === "quiz" && !this.$refs.quiz.prevAllowed) {
        return this.$refs.quiz.prevFinal();
      }
      this.screen > 0 && this.screen--;
    },
    nextScreen() {
      if (this.currentScreen.type === "quiz" && !this.$refs.quiz.nextAllowed) {
        return this.$refs.quiz.nextFinal();
      }
      if (this.screen < this.chapter.screens.length - 1) {
        this.screen++;
      } else if (this.chapter.config.next) {
        document.location = this.chapter.config.next;
      }
    },
    goHome() {
      document.location = this.chapter.config.root;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter {
  z-index: 2;
}
.fade-leave-active {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}
.module {
  &__main {
    margin: 0 0 2rem;
    position: relative;

    @include media-breakpoint-down(md) {
      margin: 0 0 0.5rem;
    }
  }
  &__video {
    position: fixed;
    z-index: 1040;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    padding: 2rem 5rem;

    @include media-breakpoint-down(lg) {
      padding: 1rem 4rem;
    }
    @include media-breakpoint-down(md) {
      padding: 1rem 3rem;
    }

    .btn {
      box-shadow: 0px 7px 10px rgba(85, 85, 112, 0.41);
      background: #fff;
      border: 1px solid #ffd100;
      cursor: pointer;
      height: 3rem;
      width: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #292983;
      position: absolute;
      right: -4rem;
      padding: 0;

      svg {
        width: 1.5rem;
        height: 1.5rem;
      }

      @include media-breakpoint-down(lg) {
        height: 2.5rem;
        width: 2.5rem;
        right: -3.5rem;
        stroke-width: 4;

        svg {
          width: 1.25rem;
          height: 1.25rem;
        }
      }

      @include media-breakpoint-down(md) {
        height: 2rem;
        width: 2rem;
        right: -2.5rem;

        svg {
          width: 1rem;
          height: 1rem;
          stroke-width: 4;
        }
      }

      &:hover {
        background: #292983;
        border-color: #292983;
        color: #fff;
      }
    }

    &-holder {
      border-top: 10px solid #ffd100;
      border-bottom: 10px solid #ffd100;
      position: relative;

      @include media-breakpoint-down(md) {
        border-top: 5px solid #ffd100;
        border-bottom: 5px solid #ffd100;
      }
    }
  }
  &__notes {
    font-size: 0.875rem;
    color: #777;
    list-style: none;
    margin: 4rem 0 -3rem 0;
    padding: 0;

    li {
      margin: 1em 0 0;
    }
  }
  &__refs {
    font-size: 0.875rem;
    color: #777;
    list-style: decimal;
    margin: 4rem 0 -2rem 1em;
    padding: 0;
  }
}
</style>
